import { ObjectFieldsChecker } from "../../../../../tools/ObjectFieldsChecker";
import { BuildingLevelUpDto } from "../../../../networking/data/responses/upgrade/BuildingLevelUpDto";
import { IBuildingRankUpModel } from "./IBuildingRankUpModel";

export class BuildingRankUpModel implements IBuildingRankUpModel {
    public readonly additionalVisitRewardPercentage: number;
    public readonly totalRewardInCoins: number;
    public readonly landlordRewardInCoins: number;
    public readonly currentGuestRewardInCoins: number;
    public readonly level: number;
    public readonly additionalPiggyBankTokensMultiplierPercentage: number;
    public readonly fromUpgrade: boolean;

    public constructor(dto: BuildingLevelUpDto, level: number) {
        ObjectFieldsChecker.throwIfInvalidFields(dto, ["additionalVisitRewardPercentage", "totalRewardInCoins", "currentGuestRewardInCoins"]);
        this.additionalVisitRewardPercentage = dto.additionalVisitRewardPercentage;
        this.totalRewardInCoins = dto.totalRewardInCoins;
        this.landlordRewardInCoins = dto.landlordRewardInCoins ?? 0;
        this.currentGuestRewardInCoins = dto.currentGuestRewardInCoins;
        this.level = level;
        this.additionalPiggyBankTokensMultiplierPercentage = dto.additionalPiggyBankTokensMultiplierPercentage;
        this.fromUpgrade = true;
    }
}
